// extracted by mini-css-extract-plugin
export default {"gallery-setting":"Home_gallery-setting__X3+45"};